import { render, staticRenderFns } from "./OrganisationAccess.vue?vue&type=template&id=15caea90&"
import script from "./OrganisationAccess.vue?vue&type=script&lang=js&"
export * from "./OrganisationAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports